import { Injectable } from '@angular/core';
import { AdditionsService } from 'core/services/additions.service';
import { Observable } from 'rxjs';
import { DynamicField } from 'shared/modules/dynamic-form/field-types';

@Injectable()
export class DefaultSenderAdditions {
  constructor(private additionsService: AdditionsService) {}

  resolve(): Observable<DynamicField[]> {
    return this.additionsService.getDefaultAdditions('sender');
  }
}
